import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule, RadioButtonModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../shared/common';
import {
  LoadingIndicatorModule
} from '../shared/layout/components/loading-indicator';
import {BreadcrumbModule} from '../shared/layout/components/breadcrumb';
import {GridModule} from '@progress/kendo-angular-grid';
import {ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {MatCardModule, MatDialogModule, MatIconModule} from '@angular/material';
import {FlexLayoutModule} from '@angular/flex-layout';
import {TitleCasePipe} from '@angular/common';
import {SchedulerModule} from '@progress/kendo-angular-scheduler';
import {MatExpansionModule} from '@angular/material/expansion';
import {BankAccountComponent} from './bank-account.component';
import {FloatingLabelModule} from '@progress/kendo-angular-label';

@NgModule({
  declarations: [
    BankAccountComponent
  ],
  imports: [
    ButtonsModule,
    DateInputsModule,
    GridModule,
    DropDownsModule,
    RadioButtonModule,
    InputsModule,
    SchedulerModule,
    FloatingLabelModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    SharedCommonModule,
    ReactiveFormsModule,
    DialogModule,
    MatDialogModule,
    MatIconModule,
    MatCardModule,
    MatExpansionModule,
    FlexLayoutModule
  ],
  exports: [
    BankAccountComponent
  ],
  providers: [
    TitleCasePipe
  ],
  entryComponents: [
  ],
})
export class BankAccountModule {
}
